var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-select", {
                    attrs: {
                      value: _vm.col.Property,
                      items: _vm.availableColumnsItems,
                      label: _vm.$ct("field"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setProperty($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("col-name") },
                    model: {
                      value: _vm.col.Name,
                      callback: function ($$v) {
                        _vm.$set(_vm.col, "Name", $$v)
                      },
                      expression: "col.Name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      decimals: 0,
                      min: _vm.minColWidth,
                      value: _vm.width,
                      label: _vm.$ct("width"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setWidth($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }